import React from 'react';
import './LandingPage.css';

const LandingPage: React.FC = () => {
  // Logo component - exact same as PaymentPage
  const Logo = () => (
    <div className="logo">
      <img 
        src="http://cdn.mcauto-images-production.sendgrid.net/a1fe588379782815/8aaa4a53-ccba-431e-b648-fde0e2fae740/4501x834.png" 
        alt="Mint House"
        style={{ 
          height: '65px', 
          width: 'auto',
          objectFit: 'contain',
          mixBlendMode: 'multiply'
        }}
      />
    </div>
  );

  return (
    <div className="landing-page">
      <div className="container">
        <div className="landing-card">
          <div className="header">
            <Logo />
          </div>

          <div className="content">
            <div className="welcome-section">
              <h1 className="title">Guest Payment Portal</h1>
              <p className="description">
                Our guest care team is here to help you complete your payment securely. 
                Please contact us using one of the methods below.
              </p>
            </div>

            <div className="contact-methods">
              <a href="sms:+16468467374" className="contact-button">
                <span className="contact-icon">📱</span>
                <span className="contact-text">Text Us: 1-646-846-7374</span>
              </a>

              <a href="tel:+18559729090" className="contact-button">
                <span className="contact-icon">📞</span>
                <span className="contact-text">Call Us: 1-855-972-9090</span>
              </a>

              <a href="mailto:info@minthouse.com" className="contact-button">
                <span className="contact-icon">✉️</span>
                <span className="contact-text">Email Us: info@minthouse.com</span>
              </a>
            </div>

            <div className="security-footer">
              <div className="security-badge">
                <span>🔒</span>
                <span className="security-text">Bank-level security • PCI DSS compliant</span>
              </div>
              
              <div className="trust-indicators">
                <div className="trust-item">
                  <span>🛡️</span>
                  <span>SSL Encrypted</span>
                </div>
                <div className="trust-item">
                  <span>🏛️</span>
                  <span>GDPR Compliant</span>
                </div>
                <div className="trust-item">
                  <span>✓</span>
                  <span>Secure Storage</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LandingPage;